// Bookkeeper packages are no longer serviced from this portal. Anyone signing
// up for - or already on - a Bookkeeper package is sent to the new Bookkeeper
// Portal instead.
export const BOOKKEEPER_PORTAL_ORIGIN = 'https://bookkeeper.finmo.co.uk';
export const BOOKKEEPER_PORTAL_URL = `${BOOKKEEPER_PORTAL_ORIGIN}/auth/`;

// Plans that live in the new Bookkeeper Portal - 'Bookkeeper', 'Bookkeeper MTD'
// and 'Bookkeeper Plus'. Only 'Bookkeeper' is listed on the pricing table (see
// planContent); the variants stay hidden, but users already on one of them
// still need sending over to the Bookkeeper Portal.
export const isBookkeeperPlan = (name) =>
  !!name && name.trim().toLowerCase().startsWith('bookkeeper');

// The redirect itself is behind a flag so it can be switched on per
// environment once the Bookkeeper Portal is live for that environment.
export const isBookkeeperRedirectEnabled =
  process.env.REACT_APP_BOOKKEEPER_PORTAL_REDIRECT === 'true';

export const shouldRedirectToBookkeeperPortal = (name) =>
  isBookkeeperRedirectEnabled && isBookkeeperPlan(name);

// Bookkeepers and accountants view self assessments in the Bookkeeper Portal
// once the redirect is enabled. Returns null when it isn't (or ids are
// missing) so callers fall back to the in-app self assessment pages.
export const getBookkeeperPortalSelfAssessmentUrl = (
  clientId,
  selfAssessmentId,
) =>
  isBookkeeperRedirectEnabled && clientId && selfAssessmentId
    ? `${BOOKKEEPER_PORTAL_ORIGIN}/bookkeeper/client/${clientId}/self-assessment/${selfAssessmentId}/overview`
    : null;

export default BOOKKEEPER_PORTAL_URL;
